import { DataType, SelectOption } from '@globaleris/ui.library'
import { EnumServicio, EnumTipoProductoCapacidad } from '../../../../api'
import { TollModel } from '../../../../api/Argentia/model/contracts'
import { enumToSelectOptionArray } from '../../../../helpers'
import { FormDialogDefinitionProps } from '../../../../hooks'
import { listTollItemMapper } from '../../contracts.mapper'
import { ProductEditFormDialogValidations } from '../../contracts.model'

export interface productFormDefinitionProps {
  t: any
  productsOps: SelectOption[]
  validationsDialog: ProductEditFormDialogValidations
  validateStartDateDialog: (startDate?: Date, endDate?: Date) => void
  validateEndDateDialog: (startDate?: Date, endDate?: Date) => void
  minStartDate: Date | undefined
  maxEndDate: Date | null | undefined
  fetchingProductsOps?: boolean
}

export const productFormDefinition = (
  mode: 'ADD' | 'EDIT' | 'DELETE',
  props: productFormDefinitionProps
) => {
  switch (mode) {
    case 'ADD':
      return productAddDefinition(props)
    case 'EDIT':
      return productEditDefinition(props)
    case 'DELETE':
      return productRemoveDefinition(props)
    default:
      return productAddDefinition(props)
  }
}

export const productAddDefinition = ({
  t,
  productsOps,
  validationsDialog,
  validateStartDateDialog,
  validateEndDateDialog,
  minStartDate,
  maxEndDate,
  fetchingProductsOps = false
}): FormDialogDefinitionProps => {
  return {
    id: 'ADD',
    sections: [
      {
        inputs: [
          {
            name: 'productId',
            label: t('contracts:components.productsTable.actions.add.inputs.product'),
            type: DataType.SELECT,
            selectOptions: productsOps,
            isLoading: fetchingProductsOps,
            required: true
          },
          {
            name: 'startDate',
            label: t('contracts:components.productsTable.actions.add.inputs.startDate'),
            type: DataType.DATE,
            required: true,
            minDate: minStartDate ?? undefined,
            maxDate: maxEndDate ?? undefined,
            errorState: !validationsDialog.startDate,
            errorText: t('contracts:notifications.errors.startDate'),
            onChange: (newStartDate: any, formState: any) => {
              validateStartDateDialog(newStartDate, formState.endDate)
            }
          },
          {
            name: 'endDate',
            label: t('contracts:components.productsTable.actions.add.inputs.endDate'),
            type: DataType.DATE,
            required: true,
            minDate: minStartDate ?? undefined,
            maxDate: maxEndDate ?? undefined,
            errorState: !validationsDialog.endDate,
            errorText: t('contracts:notifications.errors.endDate'),
            onChange: (newEndDate: any, formState: any) => {
              validateEndDateDialog(formState.startDate, newEndDate)
            }
          }
        ]
      }
    ]
  }
}

export const productEditDefinition = ({
  t,
  productsOps,
  validationsDialog,
  validateStartDateDialog,
  validateEndDateDialog,
  minStartDate,
  maxEndDate,
  fetchingProductsOps = false
}): FormDialogDefinitionProps => {
  return {
    id: 'EDIT',
    sections: [
      {
        inputs: [
          {
            name: 'productId',
            label: t('contracts:components.productsTable.actions.add.inputs.product'),
            type: DataType.SELECT,
            selectOptions: productsOps,
            required: true,
            isLoading: fetchingProductsOps
          },
          {
            name: 'startDate',
            label: t('contracts:components.productsTable.actions.add.inputs.startDate'),
            type: DataType.DATE,
            minDate: minStartDate ?? undefined,
            maxDate: maxEndDate ?? undefined,
            required: true,
            errorState: !validationsDialog.startDate,
            errorText: t('contracts:notifications.errors.startDate'),
            onChange: (newStartDate: any, formState: any) => {
              validateStartDateDialog(newStartDate, formState.endDate)
              validateEndDateDialog(newStartDate, formState.endDate)
            }
          },
          {
            name: 'endDate',
            label: t('contracts:components.productsTable.actions.add.inputs.endDate'),
            type: DataType.DATE,
            minDate: minStartDate ?? undefined,
            maxDate: maxEndDate ?? undefined,
            required: true,
            errorState: !validationsDialog.endDate,
            errorText: t('contracts:notifications.errors.endDate'),
            onChange: (newEndDate: any, formState: any) => {
              validateStartDateDialog(formState.startDate, newEndDate)
              validateEndDateDialog(formState.startDate, newEndDate)
            }
          }
        ]
      }
    ]
  }
}

export const productRemoveDefinition = ({
  t,
  productsOps,
  validationsDialog,
  validateStartDateDialog,
  validateEndDateDialog,
  minStartDate,
  maxEndDate,
  fetchingProductsOps = false
}): FormDialogDefinitionProps => {
  return {
    id: 'DELETE',
    sections: [
      {
        inputs: [
          {
            name: 'endDate',
            label: t('contracts:components.productsTable.actions.add.inputs.endDate'),
            type: DataType.DATE,
            required: true,
            errorState: !validationsDialog.endDate,
            errorText: t('contracts:notifications.errors.endDate'),
            onChange: (newEndDate: any, formState: any) => {
              validateEndDateDialog(formState.startDate, newEndDate)
            }
          }
        ]
      }
    ]
  }
}

// Capacity

export interface CapacityFormDefinitionProps {
  t: any
  tollList: TollModel[]
  pressureGroup?: number
  validationsDialog: ProductEditFormDialogValidations
  validateStartDateDialog: (startDate?: Date, endDate?: Date) => void
  validateEndDateDialog: (startDate?: Date, endDate?: Date) => void
  updateFormData: (data: any) => void
  // minStartDate: Date | undefined
  // maxEndDate: Date | null | undefined
  // fetchingProductsOps?: boolean
}

export const capacityFormDefinition = (
  mode: 'ADD' | 'EDIT' | 'DELETE',
  props: CapacityFormDefinitionProps
) => {
  switch (mode) {
    case 'ADD':
      return capacityAddDefinition(props)
    case 'EDIT':
      return capacityEditDefinition(props)
    case 'DELETE':
      return capacityEditDefinition(props)
    default:
      return capacityEditDefinition(props)
  }
}

export const capacityAddDefinition = ({
  t,
  tollList,
  pressureGroup,
  validationsDialog,
  validateStartDateDialog,
  validateEndDateDialog,
  updateFormData
}: // minStartDate,
// maxEndDate,
// fetchingProductsOps = false
CapacityFormDefinitionProps): FormDialogDefinitionProps => {
  return {
    id: 'EDIT',
    sections: [
      {
        inputs: [
          {
            name: 'code',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.code'),
            type: DataType.TEXT,
            required: true,
            onBlur: (newCode: any) => {
              newCode && updateFormData(prevState => ({ ...prevState, code: newCode }))
            }
          },
          {
            name: 'type',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.service'),
            type: DataType.SELECT,
            selectOptions: enumToSelectOptionArray(
              EnumTipoProductoCapacidad,
              'enums:EnumTipoProductoCapacidad'
            ),
            required: true
          },
          {
            name: 'toll',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.toll'),
            type: DataType.SELECT,
            selectOptions: pressureGroup
              ? listTollItemMapper(
                  tollList!.filter(
                    x => x.pressureGroupList.findIndex(x => x === pressureGroup) > -1
                  )
                )
              : listTollItemMapper(tollList!),
            required: true
          },
          {
            name: 'contractType',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.contractType'),
            type: DataType.SELECT,
            selectOptions: enumToSelectOptionArray(EnumServicio, 'enums:EnumServicio'),
            required: true
          },
          {
            name: 'qaEstimada',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.qa'),
            suffix: t('contracts:forms.add.units.kWh'),
            type: DataType.NUMBER,
            customDecimalScale: 0,
            required: true
          },
          {
            name: 'qdContratada',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.qd'),
            suffix: t('contracts:forms.add.units.kWh'),
            type: DataType.NUMBER,
            required: true
          },
          {
            name: 'startDate',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.startDate'),
            type: DataType.DATE,
            required: true,
            errorState: !validationsDialog.startDate,
            errorText: t('contracts:notifications.errors.startDate'),
            onChange: (newStartDate: any, formState: any) => {
              validateStartDateDialog(newStartDate, formState.endDate)
              validateEndDateDialog(newStartDate, formState.endDate)
            }
          },
          {
            name: 'endDate',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.endDate'),
            type: DataType.DATE,
            required: true,
            errorState: !validationsDialog.endDate,
            errorText: t('contracts:notifications.errors.endDate'),
            onChange: (newEndDate: any, formState: any) => {
              validateStartDateDialog(formState.startDate, newEndDate)
              validateEndDateDialog(formState.startDate, newEndDate)
            }
          },
          {
            name: 'rawMaterial',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.rawMaterial'),
            type: DataType.SWITCH,
            required: true,
            defaultValue: false
          }
        ]
      }
    ]
  }
}

export const capacityEditDefinition = ({
  t,
  tollList,
  pressureGroup,
  validationsDialog,
  validateStartDateDialog,
  validateEndDateDialog,
  updateFormData
}: // minStartDate,
// maxEndDate,
// fetchingProductsOps = false
CapacityFormDefinitionProps): FormDialogDefinitionProps => {
  return {
    id: 'EDIT',
    sections: [
      {
        inputs: [
          {
            name: 'code',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.code'),
            type: DataType.TEXT,
            required: true,
            onBlur: (newCode: any) => {
              newCode && updateFormData(prevState => ({ ...prevState, code: newCode }))
            }
          },
          {
            name: 'type',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.service'),
            type: DataType.SELECT,
            selectOptions: enumToSelectOptionArray(
              EnumTipoProductoCapacidad,
              'enums:EnumTipoProductoCapacidad'
            ),
            required: true
          },
          {
            name: 'toll',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.toll'),
            type: DataType.SELECT,
            selectOptions: pressureGroup
              ? listTollItemMapper(
                  tollList!.filter(
                    x => x.pressureGroupList.findIndex(x => x === pressureGroup) > -1
                  )
                )
              : listTollItemMapper(tollList!),
            required: true
          },
          {
            name: 'contractType',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.contractType'),
            type: DataType.SELECT,
            selectOptions: enumToSelectOptionArray(EnumServicio, 'enums:EnumServicio'),
            required: true
          },
          {
            name: 'qaEstimada',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.qa'),
            suffix: t('contracts:forms.add.units.kWh'),
            type: DataType.NUMBER,
            customDecimalScale: 0,
            required: true
          },
          {
            name: 'qdContratada',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.qd'),
            suffix: t('contracts:forms.add.units.kWh'),
            type: DataType.NUMBER,
            required: true
          },
          {
            name: 'startDate',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.startDate'),
            type: DataType.DATE,
            required: true,
            errorState: !validationsDialog.startDate,
            errorText: t('contracts:notifications.errors.startDate'),
            onChange: (newStartDate: any, formState: any) => {
              validateStartDateDialog(newStartDate, formState.endDate)
              validateEndDateDialog(newStartDate, formState.endDate)
            }
          },
          {
            name: 'endDate',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.endDate'),
            type: DataType.DATE,
            required: true,
            errorState: !validationsDialog.endDate,
            errorText: t('contracts:notifications.errors.endDate'),
            onChange: (newEndDate: any, formState: any) => {
              validateStartDateDialog(formState.startDate, newEndDate)
              validateEndDateDialog(formState.startDate, newEndDate)
            }
          },
          {
            name: 'rawMaterial',
            label: t('contracts:components.capacitiesTable.actions.edit.inputs.rawMaterial'),
            type: DataType.SWITCH,
            required: true
          }
        ]
      }
    ]
  }
}
